import { recordTrack } from '@saucelabs/sl-util-segmentio';
import { EVENT_CATEGORY } from '@saucelabs/sl-util-segmentio/lib/constants';

import { BUILD_STATUS, COVERAGE_TABS } from './constants';
import { OVERVIEW_TABS } from './ducks/common/test-overview/constants';

export const TRACKING_AREA = 'Insights';
export const TRACKING_SUB_AREA_DEFAULT = 'General';
export const TRACKING_SUB_AREA = Object.freeze({
  TEST_OVERVIEW: 'Jobs Overview',
  TEST_OVERVIEW_TESTS_LIST: 'Jobs Overview Tests List',
  TEST_OVERVIEW_TEST_CASE: 'Jobs Overview Test Case',
  TEST_OVERVIEW_ERRORS: 'Jobs Overview Errors',
  CONCURRENCY: 'Concurrency',
  TEST_HISTORY: 'Jobs History',
  TRENDS: 'Job Trends',
  FAILURE_ANALYSIS: 'Failure Analysis',
  [COVERAGE_TABS.devices.trackEvent]: 'Device Coverage',
  [COVERAGE_TABS.browsers.trackEvent]: 'Browser Coverage',
  [COVERAGE_TABS.os.trackEvent]: 'OS Coverage',
});

export const TEST_OVERVIEW_EVENTS = Object.freeze({
  TESTS_CSV_DOWNLOAD: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_DOWNLOADED,
    name: 'Export CSV',
  }),
  TEST_SELECTED: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate to Jobs History',
  }),
  TEST_OVERVIEW_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Jobs Overview',
  }),
  [OVERVIEW_TABS.overview.trackEvent]: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Jobs Overview tab',
  }),
  [OVERVIEW_TABS.errors.trackEvent]: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Jobs Overview Errors tab',
  }),
  [OVERVIEW_TABS.tests.trackEvent]: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate to Jobs Overview Tests tab',
  }),
  TEST_BREAKDOWN_TAB: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Jobs Breakdown Tab',
  }),
  TEST_BREAKDOWN_VERSION: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Jobs Breakdown Version',
  }),
  TEST_OVERVIEW_TESTS_SORT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Sort By Column',
  }),
  TEST_OVERVIEW_TESTS_VIEWBY_CHANGE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select View By Filter',
  }),
  TEST_OVERVIEW_ERRORS_TESTS_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Expand Tests By Error',
  }),
  TEST_OVERVIEW_ERRORS_TEST_SELECTED: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Test From Error View',
  }),
  VIEW_TESTS_BY_ERROR_PAGE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'View Tests By Error Page',
  }),
});

export const TEST_HISTORY_EVENTS = Object.freeze({
  HISTORY_PAGE_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Jobs History Page',
  }),
  HISTORY_TEST_LIST_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Jobs History Test List Page',
  }),
  TEST_CASE_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Jobs History Test Case Page',
  }),
  TEST_CASE_LINK_CLICK: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate To Single Test Case Page',
  }),
  TEST_CASE_SORTING_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Sorting On Single Test Case Page',
  }),
  TEST_CASE_PAGE_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Page On single Test Case Page',
  }),
  TESTS_CSV_DOWNLOAD: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_DOWNLOADED,
    name: 'Download Tests List CSV Report',
  }),
  TESTS_CHART_INTERVAL_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Tests Chart Time Interval',
  }),
  TESTS_CHART_BAR_CLICK: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Click On Bar Of Tests Chart',
  }),
});

export const TEST_CASE_EVENTS = Object.freeze({
  TEST_CASE_LINK_CLICK: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate To Single Test Case Page',
  }),
  TEST_CASE_SORTING_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Sorting On Single Test Case Page',
  }),
  TEST_CASE_PAGE_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Page On Single Test Case Page',
  }),
  TEST_CASE_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'View Single Test Case Page',
  }),
});

export const COVERAGE_EVENTS = Object.freeze({
  DEVICES_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Device Coverage Page',
  }),
  BROWSERS_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Browser Coverage Page',
  }),
  OS_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To OS Coverage Page',
  }),
  CSV_DOWNLOAD: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_DOWNLOADED,
    name: 'Download Coverage CSV File',
  }),
});

export const CONCURRENCY_EVENTS = Object.freeze({
  CONCURRENCY_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Concurrency Page',
  }),
  REPORT_DOWNLOAD: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_DOWNLOADED,
    name: 'Download Concurrency Report',
  }),
});

export const TRENDS_EVENTS = Object.freeze({
  TRENDS_PAGE_VIEW: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Trends Page',
  }),
  TESTS_CHART_ZOOM_IN: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'ZoomIn To Trends Tests Chart',
  }),
  BUILDS_TESTS_TAB_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Builds Test Statistics Tab',
  }),
  MORE_STATUS_INFO: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate To Test Status Document',
  }),
  COMMON_ERROR_MESSASGES: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate To Common Error Messages Document',
  }),
  [BUILD_STATUS.failed.trackEvent]: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Failed Tests Checkbox',
  }),
  [BUILD_STATUS.error.trackEvent]: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Errored Tests Checkbox',
  }),
});

export const FILTER_EVENTS = Object.freeze({
  FILTER_OPEN: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Click On Filter',
  }),
  FILTER_SELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Apply Filter',
  }),
  FILTER_DESELECT: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Remove Selected Filter',
  }),
  TIME_RANGE_OPEN: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Click On Date Filter',
  }),
  TIME_RANGE_SET: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Apply Date Filter',
  }),
  FILTER_CLEAR: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Clear Filter',
  }),
  owners: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Owner Filter',
  }),
  owner: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Owner Filter',
  }),
  build: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Build Filter',
  }),
  builds: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Build Filter',
  }),
  oses: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select OS Filter',
  }),
  os: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select OS Filter',
  }),
  browsers: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Browser Filter',
  }),
  date: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Date Filter',
  }),
  device: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Device Filter',
  }),
  framework: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Framework Filter',
  }),
  browser: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Browser Filter',
  }),
  tag: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Tag Filter',
  }),
  deviceGroup: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Select Device Group Filter',
  }),
});

export const TEST_ERRORS_EVENTS = Object.freeze({
  NAVIGATE_TO_TEST_DETAILS: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Navigate To Test Details',
  }),
  VIEW_TESTS_BY_ERROR_PAGE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'View Tests By Error Page',
  }),
  TOGGLE_ERROR_DROPDOWN: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Toggle Error Dropdown',
  }),
});

export const FAILURE_ANALYSIS_EVENTS = Object.freeze({
  FAILURE_ANALYSIS_PAGE_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Failure Analysis',
  }),
  TEST_TAB_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Failure Analysis Tests Tab',
  }),
  ROOT_CAUSE_TAB_VIEWED: Object.freeze({
    category: EVENT_CATEGORY.PAGE_VIEWED,
    name: 'Navigate To Failure Analysis Failure Patterns Tab',
  }),
  TOGGLE_TEST: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Toggle Test Name',
  }),
  TOGGLE_ROOT_CAUSE: Object.freeze({
    category: EVENT_CATEGORY.OBJECT_CLICKED,
    name: 'Toggle Failure Patterns',
  }),
});

export const trackEvent = ({ category, name, metadata }) => {
  recordTrack(category, {
    subject_name: name,
    ...metadata,
    ...(metadata?.sku_type ? { sku_type: metadata.sku_type.toUpperCase() } : null),
  });
};

/**
 * trackEventWrapper for trackEvent function
 * @param {object} metadata
 * @returns {function} a function that accepts event and eventPayload as arguments
 * @param {object} event
 * @param {object} eventPayload
 * @returns {undefined}
 */
export const trackEventWrapper = (metadata) => (event, eventPayload) => {
  trackEvent({
    ...event,
    metadata: {
      ...(typeof eventPayload === 'object' ? eventPayload : null),
      ...metadata,
    },
  });
};
